import { Table, Header, Box, StatusIndicator } from "@amzn/awsui-components-react";
import { DLQRedriveInfoResult } from "../../../lusca-search-api/generated-src";

interface DlqRedriveDetailsTableProps {
  details: DLQRedriveInfoResult;
  loading: boolean;
}

export function DlqRedriveDetailsTable({ details, loading }: DlqRedriveDetailsTableProps) {
  const items = details.result?.redrivenMessages
    ? Object.entries(details.result.redrivenMessages).map(([messageId, status]) => ({
        messageId,
        status: String(status),
      }))
    : [];

  return (
    <Table
      resizableColumns
      stickyHeader
      columnDefinitions={[
        {
          id: "messageId",
          header: "Message ID",
          cell: (item) => item.messageId,
          sortingField: "messageId",
        },
        {
          id: "status",
          header: "Status",
          cell: (item) => item.status,
          sortingField: "status",
        },
      ]}
      items={items}
      loading={loading}
      loadingText="Loading messages"
      header={
        <Header
          variant="awsui-h1-sticky"
          counter={items.length > 0 ? `(${items.length})` : undefined}
        >
          Redriven Messages
        </Header>
      }
      empty={
        <Box textAlign="center">
          <Box variant="p">No messages found</Box>
        </Box>
      }
    />
  );
}
